export default "__VITE_ASSET__Cbqcdiw9__"